module.exports = __webpack_public_path__ + "media/avatars/default-9349fc2c.svg";